export default __webpack_public_path__ + "locales/el-GR/DowngradePlanDialog.json?hash=1cac473d61e4ee1f7534f0ee0fa652a5";